<template>
  <div
    ref="personListBox"
    class="comp-container__students"
    :class="{
      'comp-container__students-horizontal': layout === 'horizontal',
      'comp-container__students-vertical': layout === 'vertical',
      'comp-container__students-speaker': layout === 'speaker',
      collapsed: collapsed,
    }"
    v-drag="layout === 'speaker' && upDateDrag"
  >
    <div
      v-show="canScrollLeft && !collapsed && layout !== 'speaker'"
      class="arrow-left arrow"
      @click="handleShowMore('left')"
    >
      <img src="@saas/pages/assets/images/live/arrow_left.png" alt="" />
    </div>
    <div class="list-container">
      <div
        class="teacher-item"
        :class="{
          'speaker-layout drag-handle': layout === 'speaker' && !collapsed,
        }"
        v-show="
          ['horizontal', 'vertical', 'speaker'].includes(layout) && !collapsed
        "
      >
        <div
          class="teacher-placeholder"
          v-if="!(teacherInfo && teacherInfo.userID)"
        >
          老师即将进入课程 请稍候
        </div>
        <teacher-video
          v-if="teacherInfo && teacherInfo.userID && shouldShowPersonVideo"
          :teacher-info="teacherInfo"
          @speaking="onSpeakerChange"
        ></teacher-video>
        <div
          class="minimize-btn"
          v-if="layout === 'speaker'"
          @click="onMinimize"
        >
          <i class="iconfont el-icon-d-arrow-left"></i>
        </div>
      </div>
      <div
        class="list-box"
        ref="listBox"
        v-show="['horizontal', 'vertical'].includes(layout)"
        @scroll="handleScroll"
      >
        <div class="scroll-box" ref="scrollBox">
          <div
            class="student-item"
            v-show="
              shouldShowPersonVideo &&
              ((isFocusMode && item.isMe) || !isFocusMode)
            "
            v-for="item in scrollPersonList"
            :key="item.userID"
          >
            <student-video
              :student-info="item"
              @speaking="onSpeakerChange"
            ></student-video>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="canScrollRight && !collapsed && layout !== 'speaker'"
      class="arrow-right arrow"
      @click="handleShowMore('right')"
    >
      <img src="@saas/pages/assets/images/live/arrow_right.png" alt="" />
    </div>
    <div
      v-if="['horizontal', 'vertical'].includes(layout)"
      class="handle-btn"
      :class="{
        'handle-btn__vertical': layout === 'vertical',
      }"
      @click="handleCollapse"
    >
      <i
        class="iconfont"
        :class="{
          'el-icon-arrow-up': layout === 'horizontal' && !collapsed,
          'el-icon-arrow-down': layout === 'horizontal' && collapsed,
          'el-icon-arrow-right': layout === 'vertical' && !collapsed,
          'el-icon-arrow-left': layout === 'vertical' && collapsed,
        }"
      ></i>
    </div>
    <!-- 最小化 -->
    <div
      class="minimize-box"
      v-if="collapsed"
      :class="{
        'drag-handle': layout === 'speaker',
      }"
    >
      <div class="speaker-box">
        <span class="label">正在讲话：</span>
        <div class="speaker-info">
          <div
            v-if="speakerInfo.isAssistant || speakerInfo.isTeacher"
            class="tag"
          >
            {{ speakerInfo.isTeacher ? "教师" : "助教" }}
          </div>
          <div class="name ellipsis">
            {{ speakerInfo.name }}
            <span
              v-if="
                speakerInfo.userID === this.userInfo.user_id &&
                !speakerInfo.isTeacher &&
                !speakerInfo.isAssistant
              "
            >
              （我）
            </span>
          </div>
        </div>
      </div>
      <el-tooltip
        v-model="openTipVisible"
        class="item"
        effect="dark"
        content="点击这里展开视频流"
        placement="bottom-start"
        :manual="true"
      >
        <div class="arrow-box" @click="handleOpen">
          <i
            class="iconfont el-icon-d-arrow-left"
            :class="{
              'arrow-horizontal':
                layout === 'horizontal' || layout === 'speaker',
            }"
          ></i>
        </div>
      </el-tooltip>
    </div>
    <!-- <kicked ref="kickedDialog"></kicked> -->
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import StudentVideo from "./StudentVideo.vue";
import TeacherVideo from "./TeacherVideo.vue";
// import SpeakerVideo from "./SpeakerVideo.vue";
// import Kicked from "../dialog/Kicked.vue";
import { drag } from "@saas/components/src/utils/drag.js";
import ScreenShareMixins from "../mixins/screen-share";
import { isTeacher, isAssistant } from "../utils";
export default {
  mixins: [ScreenShareMixins],
  components: {
    StudentVideo,
    TeacherVideo,
    // SpeakerVideo,
    // Kicked,
  },
  directives: {
    drag,
  },
  props: {},
  data() {
    return {
      personVideoWidth: 162, //一个视频的宽度px
      personVideoHeight: 94,
      speakerInfo: {},
      collapsed: false,
      canScrollLeft: false,
      canScrollRight: false,
      speakerTimer: null,
      openTipVisible: false,
      isShowedOpenTip: false,
      handUplist: [],
      upDateDrag: true,
      resizeTimer: null,
      resizeObserver: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.checkScrollStatus();
      // 监听组件区域宽度变化
      this.initResizeObserver();
    });

    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("resize", this.handleResize);
    // 销毁 ResizeObserver
    this.destroyResizeObserver();
    clearTimeout(this.resizeTimer);
    clearTimeout(this.speakerTimer);
  },
  computed: {
    ...mapState("live", [
      "isReady",
      "layout",
      "liveService",
      "imService",
      "deviceSwtich",
      "roomInfo",
      "userStatus",
      // "allMemberStatus",
      "membersStatus",
      "whiteBoardService",
      "videoPermission",
      "audioPermission",
      "screenShareStatus",
      "allMemberStatusMap",
      "isRecordPage",
    ]),
    ...mapGetters("live", ["onStageMembers"]),
    stageMembers() {
      // console.log("stageMembers_allMemberStatusMap", this.allMemberStatusMap);
      console.log("stageMembers_stageMembers", this.onStageMembers);
      return this.onStageMembers.map((item) => {
        return {
          isTeacher: isTeacher(item.user_id, this.roomInfo),
          isAssistant: isAssistant(item.user_id, this.roomInfo),
          userID: item.user_id,
          audioClose: item.audio_state !== 1 ? true : false,
          videoClose: item.video_state !== 1 ? true : false,
          name: item.nickname || item.nickname || "",
          isMe: this.userStatus.user_id === item.user_id,
          isHandUp: item.is_hand_up === 1 ? true : false,
          isReciveStream: item.is_recive_video_stream === 1 ? true : false,
          isReciveAudioStream: item.is_recive_audio_stream === 1 ? true : false,
          trophyCount: item.trophy_count || 0,
          ...item,
        };
      });
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    teacherInfo() {
      return (
        this.stageMembers.find((item) => item.isTeacher && item.status === 1) ||
        {}
      );
    },
    scrollPersonList() {
      return this.stageMembers.filter((item) => !item.isTeacher);
    },
    isScreenShare() {
      return ["start", "pause"].includes(this.screenShareStatus);
    },
    // 是否是专注模式
    isFocusMode() {
      return (
        this.roomInfo.focus_mode_state === 1 &&
        !this.roomInfo.isTeacher &&
        !this.roomInfo.isAssistant
      );
    },
    // 是否应该显示人员视频模块（大班课下台学生或助教不显示，因为 CDN 流已包含）
    shouldShowPersonVideo() {
      // 大班课下台学生或助教不显示视频模块
      if (
        this.roomInfo.is_quick_live === 1 &&
        (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
        this.userStatus.is_up_stage === 2 &&
        !this.isRecordPage
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {
    layout() {
      this.collapsed = false;
      if (this.layout === "speaker") {
        // speaker 布局不需要滚动
      } else {
        this.$nextTick(() => {
          this.checkScrollStatus();
          // 重新初始化 ResizeObserver，因为布局变化可能影响 DOM 结构
          this.destroyResizeObserver();
          this.initResizeObserver();
        });
      }
    },
    "membersStatus.length": {
      handler(val) {
        if (this.layout === "speaker") {
          // speaker 布局不需要滚动
        } else {
          this.$nextTick(() => {
            this.checkScrollStatus();
          });
        }
      },
      immediate: true,
    },
    // isReady: {
    //   handler(val) {
    //     if (val && this.liveService.isEnterRoomSuccess) {
    //       this.notifyDownStage();
    //     }
    //   },
    //   immediate: true,
    // },
    // "liveService.isEnterRoomSuccess": {
    //   handler(val) {
    //     if (val) {
    //       this.notifyDownStage();
    //     }
    //   },
    //   immediate: true,
    // },
  },

  methods: {
    ...mapMutations("live", []),
    // // 初始化的时候，如果上台，通知其他人自己上台
    // notifyDownStage() {
    //   if (this.isReady) {
    //     this.imService.sendMGLiveRoomCustomMsg({
    //       cmdId: 2,
    //       data: {
    //         type: "initUserStatus",
    //         data: {
    //           ...this.userStatus,
    //         },
    //       },
    //     });
    //     this.imService.sendMGLiveRoomCustomMsg({
    //       cmdId: 2,
    //       data: {
    //         type: "userStatus",
    //         data: {
    //           ...this.userStatus,
    //         },
    //       },
    //     });
    //   }
    // },
    // 由最小化展开
    handleOpen() {
      this.collapsed = false;
      this.upDateDrag = false;
      this.$nextTick(() => {
        this.upDateDrag = true;
      });
    },
    // 横向或者竖向布局时，折叠或者展开
    handleCollapse() {
      this.collapsed = !this.collapsed;
      if (!this.isShowedOpenTip && this.collapsed) {
        this.openTipVisible = true;
        this.isShowedOpenTip = true;
        setTimeout(() => {
          this.openTipVisible = false;
        }, 5000);
      }
      setTimeout(() => {
        // 白板大小重置
        if (this.whiteBoardService?.resizeBoard) {
          this.whiteBoardService.resizeBoard();
        }
      }, 300);
    },

    handleScroll() {
      this.checkScrollStatus();
    },

    checkScrollStatus() {
      const listBox = this.$refs.listBox;
      if (!listBox) return;

      if (this.layout === "horizontal") {
        // 检查是否需要显示左右箭头
        const hasHorizontalScroll = listBox.scrollWidth > listBox.clientWidth;

        if (
          hasHorizontalScroll &&
          listBox.scrollWidth > 0 &&
          listBox.clientWidth > 0
        ) {
          this.canScrollLeft = listBox.scrollLeft > 0;
          this.canScrollRight =
            listBox.scrollLeft < listBox.scrollWidth - listBox.clientWidth - 1; // 减去1px避免精度问题
        } else {
          this.canScrollLeft = false;
          this.canScrollRight = false;
        }
      } else if (this.layout === "vertical") {
        // 检查是否需要显示上下箭头
        const hasVerticalScroll = listBox.scrollHeight > listBox.clientHeight;

        if (
          hasVerticalScroll &&
          listBox.scrollHeight > 0 &&
          listBox.clientHeight > 0
        ) {
          this.canScrollLeft = listBox.scrollTop > 0;
          this.canScrollRight =
            listBox.scrollTop < listBox.scrollHeight - listBox.clientHeight - 1; // 减去1px避免精度问题
        } else {
          this.canScrollLeft = false;
          this.canScrollRight = false;
        }
      }
    },
    // 展示更多
    handleShowMore(arrow) {
      if (this.layout === "horizontal") {
        let scrollDistance = this.$refs.listBox.clientWidth * 0.8;
        const remainder = scrollDistance % this.personVideoWidth;
        scrollDistance -= remainder;
        if (arrow === "left") {
          this.$refs.listBox.scrollLeft -= scrollDistance;
        } else {
          this.$refs.listBox.scrollLeft += scrollDistance;
        }
      } else {
        let scrollDistance = this.$refs.listBox.clientHeight * 0.8;
        const remainder = scrollDistance % this.personVideoHeight;
        scrollDistance -= remainder;
        if (arrow === "left") {
          this.$refs.listBox.scrollTop -= scrollDistance;
        } else {
          this.$refs.listBox.scrollTop += scrollDistance;
        }
      }

      // 滚动后重新检查状态
      this.$nextTick(() => {
        this.checkScrollStatus();
      });
    },
    //
    onSpeakerChange(info) {
      this.speakerInfo = info;
      clearTimeout(this.speakerTimer);
      this.speakerTimer = setTimeout(() => {
        this.speakerInfo = {};
      }, 200);
    },
    onMinimize() {
      this.collapsed = true;
      this.upDateDrag = false;
      this.$nextTick(() => {
        this.upDateDrag = true;
      });
    },

    handleResize() {
      // 使用防抖来避免频繁调用
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.checkScrollStatus();
      }, 100);
    },

    initResizeObserver() {
      // 检查浏览器是否支持 ResizeObserver
      if (typeof ResizeObserver !== "undefined") {
        try {
          this.resizeObserver = new ResizeObserver((entries) => {
            // 使用防抖来避免频繁调用
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
              this.checkScrollStatus();
            }, 100);
          });

          // 监听组件容器和列表容器的尺寸变化
          if (this.$refs.personListBox) {
            this.resizeObserver.observe(this.$refs.personListBox);
          }
          if (this.$refs.listBox) {
            this.resizeObserver.observe(this.$refs.listBox);
          }
        } catch (error) {
          console.warn("ResizeObserver 初始化失败:", error);
        }
      }
    },

    destroyResizeObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container__students {
  width: 100%;
  height: 104px;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  position: relative;
  z-index: 990;
  .list-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .list-box {
    height: 100%;
    overflow: auto;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      background-color: transparent;
    }
  }
  .teacher-item {
    width: 160px;
    min-width: 160px;
    height: 92px;
    min-height: 92px;
    margin: 0px 3px;
    background: transparent;
    border-radius: 6px;
    position: relative;
    .teacher-placeholder {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #27272a;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #fff;
      padding: 16px;
      text-align: center;
      border-radius: 6px;
      overflow: hidden;
    }
    .minimize-btn {
      color: #fff;
      width: 24px;
      height: 24px;
      background: rgba(24, 24, 27, 0.6);
      border-radius: 6px 6px 6px 6px;
      border: 1px solid rgba(24, 24, 27, 0.1);
      cursor: pointer;
      display: none;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      position: absolute;
      top: 4px;
      right: 4px;
      z-index: 1;
      i {
        transform: rotate(90deg);
      }
    }
    &:hover {
      .minimize-btn {
        display: flex;
      }
    }
  }
  .scroll-box ::v-deep {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .student-item {
      width: 160px;
      min-width: 160px;
      height: 92px;
      min-height: 92px;
      margin: 0px 3px;
      background: transparent;
      border-radius: 6px;
      position: relative;
    }
    .teacher-placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #fff;
      padding: 16px;
      text-align: center;
    }
  }
  .handle-btn {
    width: 42px;
    height: 18px;
    background: rgba(63, 63, 70, 0.4);
    border-radius: 12px 12px 12px 12px;
    position: absolute;
    left: 50%;
    bottom: -18px;
    transform: translateX(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer !important;
    i {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .handle-btn__vertical {
    width: 18px;
    height: 42px;
    top: 50%;
    transform: translateY(-50%);
    left: -18px;
  }
}
.comp-container__students-horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 12px;
  transform: translate(0, 0) !important;
  .list-container {
    flex: 1;
    overflow: hidden;
    flex-direction: row;
  }
  .list-box {
    // flex: 1;
    overflow-y: hidden;
  }
  .arrow {
    width: 40px;
    height: 40px;
    cursor: pointer;
    &.arrow-left {
      margin-right: 9px;
    }
    &.arrow-right {
      margin-left: 9px;
    }
  }
  .scroll-box {
    width: max-content;
    min-width: 100%;
  }
  &.collapsed {
    height: 0;
    .list-container {
      height: 0;
      overflow: hidden;
    }
    .list-box {
      height: 0;
      overflow: hidden;
    }
  }
}
.comp-container__students-vertical {
  width: 172px;
  height: 100%;
  background: #18181b;
  border-radius: 0px 0px 0px 0px;
  // border: 1px solid rgba(229, 231, 235, 0.04);
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  transform: translate(0, 0) !important;

  .list-container {
    flex: 1;
    flex-direction: column;
    overflow: hidden;
  }
  .list-box {
    // flex: 1;
    height: auto;
    overflow-x: hidden;
  }
  .arrow {
    width: 40px;
    height: 40px;
    cursor: pointer;
    &.arrow-left {
      transform: rotate(90deg);
      margin-bottom: 9px;
    }
    &.arrow-right {
      transform: rotate(90deg);
      margin-top: 9px;
    }
  }
  &.collapsed {
    width: 0;
    .list-container {
      width: 0;
      overflow: hidden;
    }
    .list-box {
      width: 0;
      overflow: hidden;
    }
  }
  .scroll-box ::v-deep {
    height: max-content;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .student-item {
      width: 156px;
      height: 88px;
      margin: 3px 0px;
      width: 156px;
      height: 88px;
      background: #27272a;
      border-radius: 10px 10px 10px 10px;
      position: relative;
    }
  }
}
.comp-container__students-speaker {
  width: 156px;
  height: 88px;
  border-radius: 12px 12px 12px 12px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 990;
  &.collapsed {
    width: 250px;
    height: 44px;
    .minimize-box {
      right: 0;
      top: 0;
    }
  }
}
.comp-container__students-screen-share {
  width: 172px;
  border-radius: 0px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 999;
  top: 100px;
  right: 60px;
  background: #18181b;
  .list-container {
    flex: 1;
    flex-direction: column;
    overflow: hidden;
  }
  .list-box {
    // flex: 1;
    height: auto;
    overflow-x: hidden;
  }
  .arrow {
    margin: 12px 0;
    width: 40px;
    height: 40px;
    cursor: pointer;
    &.arrow-left {
      transform: rotate(90deg);
    }
    &.arrow-right {
      transform: rotate(90deg);
    }
  }
  &.collapsed {
    width: 0;
    .list-container {
      width: 0;
      overflow: hidden;
    }
    .list-box {
      width: 0;
      overflow: hidden;
    }
  }
  .scroll-box ::v-deep {
    height: max-content;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .student-item {
      width: 156px;
      height: 88px;
      margin: 3px 0px;
      width: 156px;
      height: 88px;
      background: #27272a;
      border-radius: 10px 10px 10px 10px;
      position: relative;
    }
  }
}
.minimize-box {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 250px;
  height: 44px;
  background: #18181b;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ecedee;
  .speaker-box {
    flex: 1;
    display: flex;
    padding: 0 12px;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    .label {
      min-width: 70px;
    }
    .speaker-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .tag {
        min-width: 30px;
        border-radius: 8px;
        margin: 0 3px;
        color: #17c964;
        padding: 0 3px;
        background: #052814;
        font-weight: 500;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .arrow-box {
    cursor: pointer;
    width: 44px;
    height: 100%;
    min-width: 44px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid rgba(229, 231, 235, 0.04);
    .arrow-horizontal {
      transform: rotate(-90deg);
    }
  }
}
</style>
